// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1811": "6c80ff5f","1850": "56b71224","6754": "3b831bbe","9066": "c1fdd670",}[chunkId] + ".css"
}